import { CKContainerProps, CKDetailGroup, CKNavigationBar } from 'clearkit';
import { useState } from 'react';

import { NavRouterItem } from '~/components/NavBar/NavRouterItem';

import { ProspectorListItem } from './types';

type ListProps = CKContainerProps & {
  items: ProspectorListItem[];
  title: string;
};

export const List = ({
  className,
  children,
  items,
  title,
  ...rest
}: ListProps) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <CKDetailGroup
      className={className}
      {...rest}
      isOpen={isOpen}
      onToggle={() => setIsOpen(!isOpen)}
    >
      <CKDetailGroup.TriggerChevron className="flex justify-between w-full !pl-3">
        <strong className="font-medium">{title}</strong>
      </CKDetailGroup.TriggerChevron>
      <CKDetailGroup.Group className="space-y-1">
        {items.map((item, index) => (
          <NavRouterItem
            className="!font-normal"
            key={index}
            label={item.title}
            to={item.to}
          >
            <CKNavigationBar.ItemLeft>{children}</CKNavigationBar.ItemLeft>
          </NavRouterItem>
        ))}
      </CKDetailGroup.Group>
    </CKDetailGroup>
  );
};
